import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpServiceBase } from '../classes/HttpServiceBase';

/**
 * The non-admin file-download portal (backend rest/fyes/portal/files).
 * Returns the logged-in user's categories, each with its files; downloads are
 * scoped server-side to the user's own categories.
 */
@Injectable({ providedIn: 'root' })
export class PortalFilesService extends HttpServiceBase {
    protected override baseUrl = '/portal/files';

    constructor(private http: HttpClient) {
        super();
        this.assign(this);
    }

    /** GET /portal/files -> grouped {categoryId, categoryName, files[]}. */
    public list(): Observable<any> {
        return this._http.get(this.baseUrl)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    /** GET /portal/files/:id/download -> presigned URL for one file. */
    /**
     * Short-lived presigned URL for the stored object.
     *
     * `inline` asks for a URL the browser will render (no Content-Disposition);
     * otherwise the URL forces a download under the original filename.
     */
    public getDownloadUrl(id: string, inline = false): Observable<any> {
        return this._http.get(`${this.baseUrl}/${id}/download`, { params: { inline } })
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }
}
